import { state } from './state.js';

const translations = {
  sv: {
    start_case: 'Starta Narkos',
    stop_case: 'Avsluta Narkos',
    mode_auto: 'Auto',
    mode_manual: 'Manuell',
    tab_values: 'Värden',
    tab_status: 'Status',
    tab_journal: 'Journal',
    settings: 'Inställningar',
    new_case: '🆕 Ny Narkos',
    cancel: 'Avbryt',
    save: 'Spara',
    species: 'Djur',
    dog: '🐶 Hund',
    cat: '🐱 Katt',
    weight: 'Vikt (kg)',
    bcs: 'BCS (1-9)',
    comorbidities: 'Komorbiditeter (Frivilligt)',
    nurse_sign: 'Signatur (DSS/DV/VET)',
    capture_interval: 'Auto-intervall:',
    language: 'Språk',
    copy_all: 'Kopiera Allt',
    status_idle: 'Väntar på värden...',
    status_ok: 'Troligen normalt',
    status_warning: 'Möjlig avvikelse/Artefakt',
    status_critical: 'Kritisk avvikelse(r)',
    status_processing: 'Analyserar bild...',
    status_analyzing: 'Analyserar data...',
    assessment_tier_flash: '⚡ Snabb',
    assessment_tier_pro: '🧠 Pro',
    assessment_trends: 'Trender',
    assessment_recommendations: 'Åtgärder',
    assessment_errors: 'AI-logg',
    assessment_confidence_high: 'Hög',
    assessment_confidence_medium: 'Medel',
    assessment_confidence_low: 'Låg',
    error_log_empty: 'Inga fel',
    btn_capture: 'Fota',
    app_settings: 'App',
    case_settings: 'Patient',
    end_case_confirm: 'Avsluta denna narkos?',
    journal_note_placeholder: 'Lägg till Anmärkning och tryck Enter...',
    no_notes: 'Inga anmärkningar',
    decimal_sep: ',',
    data_age_suffix: 'min gammal',
    protocol: 'Protokoll',
    edit_protocols: 'Redigera Protokoll',
    add_protocol: 'Nytt Protokoll',
    share_protocol: 'Dela Protokoll',
    delete_protocol: 'Radera',
    import_protocol_title: 'Importera Protokoll',
    import_protocol_msg: 'Vill du importera protokollet',
    add_btn: 'Lägg till',
    replace_btn: 'Ersätt',
    share_session: 'Dela narkos',
    session_shared: 'Narkos delas',
    link_copied: 'Länk kopierad till urklipp!',
    session_joined: 'Ansluten till narkos',
    session_join_failed: 'Kunde inte ansluta till narkos',
    start_case_first: 'Starta en narkos först',
    disconnect_case: 'Koppla från',
    disconnect_confirm_title: 'Koppla från?',
    disconnect_confirm_text: 'Vill du koppla från den delade sessionen? Narkosen fortsätter för andra användare.',
    collaborate: 'Samarbeta',
    btn_live_view: '👆 Tryck för bild',
    error_camera_access: 'Kameraåtkomst nekad eller otillgänglig.',
    btn_expand: '📷»',
    btn_collapse: '«📷',
    waking_camera: '📷 Startar...',
    case_history: 'Historik',
    resume_case: 'Återuppta',
    no_cases: 'Inga sparade narkoser',
    resume_confirm: 'Återuppta denna narkos?',
    delete_case: 'Radera journal?',
    copy_to_journal: 'Kopiera för Journal',
    copied: 'Kopierat!',
    shared: 'Delad',
    local: 'Lokal',
    help_about: 'Hjälp / Om',
    welcome_title: 'Välkommen!',
    welcome_text: 'För att börja, vänligen ange din signatur för journalen. Du kan ändra denna senare i Inställningar.',
    onboarding_next: 'Nästa',
    onboarding_done: 'Kom igång',
    guide_title: 'Guide & Hjälp',
    guide_text: 'Här är en snabb genomgång av appens funktioner:',
    guide_auto_title: 'Auto-läge',
    guide_auto_desc: 'Appen fotar skärmen automatiskt och läser av värden.',
    guide_manual_title: 'Manuellt',
    guide_manual_desc: 'Klicka på ett värde för att knappa in det själv.',
    guide_camera_title: 'Kameravy',
    guide_camera_desc: 'Dölj kamerabilden för att se fler värden och spara batteri.',
    guide_journal_title: 'Journal',
    guide_journal_desc: 'Alla värden sparas i journalen var 5:e minut.',
    guide_settings_title: 'Inställningar',
    guide_settings_desc: 'Här kan du ändra djurart, vikt och protokoll.',
    guide_share_title: 'Dela Narkos',
    guide_share_desc: 'Klicka på 🔗 i statusfältet för att skärmdela monitorn eller journalen.',
    guide_share_protocol_title: 'Dela Protokoll',
    guide_share_protocol_desc: 'I inställningarna kan du skapa nya larmvärden och dela dem som länk.',
    about_version: 'Version: ',
    about_copyright: '© 2026 Andrei Ignat',
    about_contact: 'Kontakt:',
    about_linkedin: 'LinkedIn',
    unreasonable_value_warning: 'Orimliga värden upptäckta',
    confirm_save_anyway: 'Spara ändå?',
    protocols: 'Protokoll',
    manage_protocols: 'Hantera Protokoll',
    protocol_settings: 'Protokollinställningar',
    select_protocol: 'Välj Protokoll',
    custom_ai_instructions: 'Anpassade AI-instruktioner',
    done: 'Klar',
    tap_to_enter: 'Klicka för att ange'
  },
  en: {
    start_case: 'Start Case',
    stop_case: 'Stop Case',
    mode_auto: 'Auto',
    mode_manual: 'Manual',
    tab_values: 'Values',
    tab_status: 'Status',
    tab_journal: 'Journal',
    settings: 'Settings',
    new_case: '🆕 New Case',
    cancel: 'Cancel',
    save: 'Save',
    species: 'Species',
    dog: '🐶 Dog',
    cat: '🐱 Cat',
    weight: 'Weight (kg)',
    bcs: 'BCS (1-9)',
    comorbidities: 'Comorbidities (Optional)',
    nurse_sign: 'Signature (Tech/DVM)',
    capture_interval: 'Auto-Capture Interval:',
    language: 'Language',
    copy_all: 'Copy All',
    status_idle: 'Waiting for values...',
    status_ok: 'Likely Normal',
    status_warning: 'Possible Artifact/Warning',
    status_critical: 'Critical Deviation(s)',
    status_processing: 'Analyzing image...',
    status_analyzing: 'Analyzing data...',
    assessment_tier_flash: '⚡ Fast',
    assessment_tier_pro: '🧠 Pro',
    assessment_trends: 'Trends',
    assessment_recommendations: 'Recommendations',
    assessment_errors: 'AI Log',
    assessment_confidence_high: 'High',
    assessment_confidence_medium: 'Medium',
    assessment_confidence_low: 'Low',
    error_log_empty: 'No errors',
    btn_capture: 'Capture',
    app_settings: 'App',
    case_settings: 'Patient',
    end_case_confirm: 'End this case?',
    journal_note_placeholder: 'Add note and press Enter...',
    no_notes: 'No notes',
    decimal_sep: '.',
    data_age_suffix: 'min old',
    protocol: 'Protocol',
    edit_protocols: 'Edit Protocols',
    add_protocol: 'New Protocol',
    share_protocol: 'Share Protocol',
    delete_protocol: 'Delete',
    import_protocol_title: 'Import Protocol',
    import_protocol_msg: 'Do you want to import protocol',
    add_btn: 'Add',
    replace_btn: 'Replace',
    share_session: 'Share case',
    session_shared: 'Case shared',
    link_copied: 'Link copied to clipboard!',
    session_joined: 'Joined case',
    session_join_failed: 'Failed to join case',
    start_case_first: 'Start a case first',
    disconnect_case: 'Disconnect',
    disconnect_confirm_title: 'Disconnect?',
    disconnect_confirm_text: 'Do you want to disconnect from the shared session? The case will continue for other users.',
    btn_live_view: '👆 Tap for Camera',
    error_camera_access: 'Camera access denied or unavailable.',
    btn_expand: '📷»',
    btn_collapse: '«📷',
    waking_camera: '📷 Waking...',
    case_history: 'History',
    resume_case: 'Resume',
    no_cases: 'No saved cases',
    resume_confirm: 'Resume this case?',
    delete_case: 'Delete journal?',
    copy_to_journal: 'Copy to Journal',
    copied: 'Copied!',
    shared: 'Shared',
    local: 'Local',
    help_about: 'Help / About',
    welcome_title: 'Welcome!',
    welcome_text: 'To get started, please provide your signature for the journal. You can change this later in Settings.',
    onboarding_next: 'Next',
    onboarding_done: 'Get Started',
    guide_title: 'Guide & Help',
    guide_text: 'Here is a quick overview of the app features:',
    guide_auto_title: 'Auto Mode',
    guide_auto_desc: 'The app captures the screen automatically and reads values.',
    guide_manual_title: 'Manual Entry',
    guide_manual_desc: 'Tap any value to enter it manually.',
    guide_camera_title: 'Collapsing Camera',
    guide_camera_desc: 'Hide the camera feed to see all values and save battery.',
    guide_journal_title: 'Journal',
    guide_journal_desc: 'All values are saved to the journal every 5 minutes.',
    guide_settings_title: 'Settings',
    guide_settings_desc: 'Change species, weight, and protocols here.',
    guide_share_title: 'Share Case',
    guide_share_desc: 'Click on 🔗 in the status bar to share the live monitor or history.',
    guide_share_protocol_title: 'Share Protocols',
    guide_share_protocol_desc: 'In settings you can add new alarm limits and share them as a link.',
    about_version: 'Version: ',
    about_copyright: '© 2026 Andrei Ignat',
    about_contact: 'Contact:',
    about_linkedin: 'LinkedIn',
    unreasonable_value_warning: 'Unreasonable value(s) detected',
    confirm_save_anyway: 'Save anyway?',
    protocols: 'Protocols',
    manage_protocols: 'Manage Protocols',
    protocol_settings: 'Protocol Settings',
    select_protocol: 'Select Protocol',
    custom_ai_instructions: 'Custom AI Instructions',
    done: 'Done',
    tap_to_enter: 'Tap to enter'
  }
};

export function t(key) {
  const lang = state.get('lang') || 'sv';
  return translations[lang][key] || key;
}

// Helper to re-render all translations tagged with data-i18n
export function updateI18n() {
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (el.tagName === 'INPUT' && el.type === 'text') {
      el.placeholder = t(key);
    } else {
      el.textContent = t(key);
    }
  });
}
